import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Import actions and selectors
import { signOut } from 'store/actions';
import { authSelectors } from 'store/selectors';

export const useSignOutButton = () => {
	const [isLoading, setIsLoading] = useState(false);

	const isAuthenticated = useSelector(authSelectors.isAuthenticated);

	const dispatch = useDispatch();

	const handleOnClick = () => {
		setIsLoading(true);

		signOut()(dispatch).finally(() => {
			setIsLoading(false);
		});
	};

	return {
		onClick: handleOnClick,
		isAuthenticated,
		isLoading,
	};
};
